"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeAssert = exports.assert = exports.AssertionError = void 0;
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(invalidations) {
        var _this = this;
        var longestPathLength = invalidations.reduce(function (previous, _a) {
            var path = _a.path;
            return previous < path.length ? path.length : previous;
        }, 0);
        var sortedInvalidations = invalidations
            .filter(function (_a) {
            var path = _a.path;
            return path.length === longestPathLength;
        })
            .sort(function (_a, _b) {
            var left = _a.rule;
            var right = _b.rule;
            return left !== 'type' && right === 'type' ? -1 : left === 'type' && right !== 'type' ? 1 : 0;
        })
            .sort(function (_a, _b) {
            var left = _a.path;
            var right = _b.path;
            return left.length > right.length ? -1 : left.length < right.length ? 1 : 0;
        });
        var bestGuessInvalidation = sortedInvalidations[0];
        var path = pathLiteral(bestGuessInvalidation.path);
        var escape = function (value) {
            return typeof value === 'string' ? "\"" + value + "\"" : Array.isArray(value) ? "[" + value.map(escape).join(', ') + "]" : "" + value;
        };
        var rule = bestGuessInvalidation.rule, setting = bestGuessInvalidation.setting, actual = bestGuessInvalidation.actual;
        _this = _super.call(this, path + " - expected \"" + rule + "\" of " + escape(setting) + ", but received " + escape(actual)) || this;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // Set the prototype explicitly.
        Object.setPrototypeOf(_this, AssertionError.prototype);
        _this.invalidations = sortedInvalidations;
        return _this;
    }
    return AssertionError;
}(Error));
exports.AssertionError = AssertionError;
/**
 * Asserts `value` to be valid according to `guard`. If `value` is invalid a AssertionError will be thrown.
 * @param guard type-guard used for assertion
 * @param value value to be asserted
 * @param error error to be trown when assertion fails
 */
function assert(guard, value, error) {
    var iterator = guard.validate([], value);
    var _a = iterator.next(), done = _a.done, invalidation = _a.value;
    if (done !== true) {
        var invalidations = __spreadArray([invalidation], __read(iterator), false);
        if (error instanceof Error) {
            throw error;
        }
        else if (typeof error === 'string') {
            throw new Error(error);
        }
        else if (typeof error === 'function') {
            throw error(invalidations);
        }
        else {
            throw new AssertionError(invalidations);
        }
    }
}
exports.assert = assert;
/**
 * Fake asserts `value` against `guard` to get the correct type for value.
 * @param guard type-guard used for assertion
 * @param value value to be asserted
 * @param error error to be trown when assertion fails
 */
function fakeAssert(guard, value) { }
exports.fakeAssert = fakeAssert;
var pathLiteral = function (path) {
    return path.reduce(function (previous, current, index) {
        var currentType = typeof current;
        if (index === 0) {
            if (typeof currentType === 'string') {
                return "[\"" + current + "\"]";
            }
            else {
                return "[" + current + "]";
            }
        }
        if (current === null) {
            return previous + "[null]";
        }
        else if (current === undefined) {
            return previous + "[undefined]";
        }
        else if (currentType === 'bigint' ||
            currentType === 'boolean' ||
            currentType === 'number' ||
            currentType === 'symbol') {
            return previous + "[" + current + "]";
        }
        else {
            return previous + "[\"" + current + "\"]";
        }
    }, '');
};
